<script lang="ts" setup>
import chevronRightIcon from '@/assets/img/icon/chevron-right-icon.svg';
import closeIcon from '@/assets/img/icon/close-icon.svg';
import dashboardIcon from '@/assets/img/icon/dashboard-icon.svg';
import settingsIcon from '@/assets/img/icon/settings-icon.svg';
import { AppButton, AppTypography } from '@/core/components';
import { useMobileStore } from '@/store/mobile';
import { storeToRefs } from 'pinia';
import DialogConfirmation from './dialogs/DialogConfirmation.vue';

const mobileStore = useMobileStore();
const { showMenu } = storeToRefs(mobileStore);
const { toggleMenu } = mobileStore;
const showConfirmDialog = ref(false);
const menuItems = [
  {
    icon: dashboardIcon,
    name: 'Dashboard',
    label: 'View teams & players',
    to: '/',
  },
  {
    icon: settingsIcon,
    name: 'Settings',
    label: 'Manage your account & preferences',
    to: '/account',
  },
];

const router = useRouter();
const { pending: loadingLogout, execute: executeLogout } = useSubmit();

const handleLogout = async () => {
  await executeLogout('/auth/logout', { method: 'POST' });
  const accessToken = useCookie('auth:token');
  accessToken.value = null;
  router.go(0);
};
</script>
<template>
  <v-navigation-drawer v-model="showMenu" temporary location="right" class="fullscreen-drawer">
    <div class="d-flex flex-column justify-space-between full-height">
      <div>
        <div class="mb-10">
          <v-btn class="circle-btn border-ring" @click="toggleMenu(false)">
            <v-img :src="closeIcon" width="12" height="12" />
          </v-btn>
        </div>
        <v-card flat class="border-radius-2xl drawer-list">
          <div v-for="(navMenu, index) in menuItems" :key="`navmenu-${index}`">
            <v-list-item link :to="navMenu.to">
              <div class="d-flex align-center justify-space-between drawer-list-item">
                <div class="d-flex align-center">
                  <v-img :src="navMenu.icon" width="24" height="24" />
                  <div class="ml-3">
                    <AppTypography element="h5" class="font-body-regular">{{ navMenu.name }}</AppTypography>
                    <AppTypography element="p" class="font-foot-note-regular">{{ navMenu.label }}</AppTypography>
                  </div>
                </div>
                <div class="mr-2">
                  <v-img :src="chevronRightIcon" width="24" height="24" />
                </div>
              </div>
            </v-list-item>
            <div v-if="index < menuItems.length - 1" class="drawer-list-divider">
              <v-divider></v-divider>
            </div>
          </div>
        </v-card>
      </div>
      <div>
        <AppButton color="default" block data-cy="submit" data-testid="submit" @click="showConfirmDialog = true">
          Logout
        </AppButton>
      </div>
      <DialogConfirmation
        v-model="showConfirmDialog"
        :width="420"
        title="Are you sure you want to log out?"
        message=""
        confirmMessage="Yes, Log out"
        @close="showConfirmDialog = false"
        @confirm="handleLogout()"
      />
    </div>
  </v-navigation-drawer>
</template>
<style lang="scss" scoped>
.v-navigation-drawer--active {
  width: 100vw !important;
  padding: 20px;
}

.fullscreen-drawer {
  background: rgb(var(--v-theme-background-body)) !important;
  top: 0 !important;
  z-index: 999 !important;
  height: 100dvh !important;
  // height: 100vh !important;
  .v-navigation-drawer__content {
    height: 100% !important;
  }
}

@media (min-width: 768px) {
  .v-navigation-drawer--active {
    width: auto !important;
  }
}

:deep(.v-list-item__overlay) {
  background-color: rgb(var(--v-theme-surface-background)) !important;
}

.drawer-list {
  .v-list-item {
    min-height: 64px;

    p {
      color: rgb(var(--v-theme-text-secondary));
    }
  }

  &-divider {
    padding-left: 52px;
    padding-right: 20px;
  }
}

@media (max-width: 767px) {
  .drawer-list {
    padding: 4px 0;

    .v-list-item {
      height: 64px;
    }
  }
}
</style>
